export default class ExportTripRatePeakHourGraphViewModel {
    exportType: "PDF" | "JPEG" = "PDF";
    addUserComments: boolean = false;
    userComment: string | null = null;
    displayToScreen: boolean = true;
    fileName: string = "Trip Rate Peak Hour Graph";
    peakHour: PeakHourChartViewModel[] = [];
    mainUse: string = "";
    subUse: string = "";
    direction: string = "";
    surveyType: string = "";
    vehicleType: number = 0;
}